export const FEATURES = {
  websocket: (typeof import.meta !== 'undefined' && (import.meta as any).env) 
    ? (import.meta as any).env.VITE_ENABLE_WEBSOCKET === 'true' 
    : false,
};
